import React from 'react';
import {connect} from "react-redux";
import Grid from '@material-ui/core/Grid';
import HomePage from "./pages/home_page";

class Welcome extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {digitalProfileSettings} = this.props;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <HomePage digitalProfileSettings={digitalProfileSettings} />
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    const {digitalProfileSettings} = state;
    return {
        digitalProfileSettings,
    };
}

export default connect(mapStateToProps)(Welcome);
